import { useTranslation } from 'react-i18next';
import { Store } from 'lucide-react';
import { cn } from 'lib/utils';
import EmptyState from 'components/EmptyState';
import type { StoreDrift } from 'api/sectorAlignmentApi';
import { list, STORES_GRID, type Tagged } from './rows';
import StoreRow from './StoreRow';

/** Board 4: one expandable row per store, its tickets underneath. */
const StoresTab = ({ stores, filtered }: { stores: Tagged<StoreDrift>[]; filtered: boolean }) => {
  const { t } = useTranslation();
  if (stores.length === 0) return filtered ? <EmptyState title={t('No result for this filter')} /> : <EmptyState icon={Store} title={t('No misaligned store')} />;
  const tickets = stores.reduce((sum, s) => sum + list(s.tickets).length, 0);

  return (
    <>
      <div role="table" aria-label={t('Stores')}>
        <div role="row" className={cn(STORES_GRID, 'h-[42px] border-b text-xs font-semibold text-muted-foreground')}>
          <span role="columnheader">{t('Store')}</span>
          <span role="columnheader">{t('Desk')}</span>
          <span role="columnheader">{t("Tickets' sector → store's sector")}</span>
          <span role="columnheader" className="text-right">{t('Tickets')}</span>
        </div>
        {stores.map((drift) => <StoreRow key={`${drift.sd}-${drift.store}-${drift.currentSector}`} drift={drift} />)}
      </div>
      <p className="border-t px-5 py-[11px] text-[12.5px] text-muted-foreground">
        {t('{{stores}} · {{tickets}}', {
          stores: t('{{count}} store', { count: stores.length }),
          tickets: t('{{count}} ticket', { count: tickets }),
        })}
      </p>
    </>
  );
};

export default StoresTab;
